// extracted by mini-css-extract-plugin
export default {"mainHero":"Blog_mainHero__cIwgo"};